import { render, staticRenderFns } from "./OperaAnchorWindow.vue?vue&type=template&id=7e31b2ba&"
import script from "./OperaAnchorWindow.vue?vue&type=script&lang=js&"
export * from "./OperaAnchorWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports